import { companyQueryOptions } from '@/hooks/queries/company.queries';
import type { ApiCompanyProfessionals } from '@/types/api';
import type { ListResponseDto } from '@/types/ListResponse.dto';
import { useQuery } from '@tanstack/react-query';

type CompanyProfessionalsQueryData = ApiCompanyProfessionals[] | ListResponseDto<ApiCompanyProfessionals[]>;

export function normalizeCompanyProfessionals(data?: CompanyProfessionalsQueryData) {
  if (!data) {
    return [];
  }

  return Array.isArray(data) ? data : data.data;
}

export function useCompanyProfessionals(companyId?: string, mode?: 'SCHEDULE_ONLY' | 'QUEUE_ONLY') {
  const { data, isError, isFetching, isLoading, refetch } = useQuery(companyQueryOptions.professionals(companyId));

  return {
    isError,
    isFetching,
    isLoading,
    professionals: normalizeCompanyProfessionals(data).filter(
      (professional) =>
        (!mode ||
          !professional.operationMode ||
          professional.operationMode === 'HYBRID' ||
          professional.operationMode === mode) &&
        (mode !== 'QUEUE_ONLY' || professional.hasActiveWalkInQueue === true),
    ),
    refetch,
  };
}
